#import "./CanvasBlockBaseFields.graphql"

fragment ListBlockFields on ListBlock {
  ...CanvasBlockBaseFields
  items {
    text
  }
}
